import ActionText from '../../core/ActionText';
import MenuSelector from '../../core/MenuSelector';
import Paging from '../../core/Paging';
import Tooltip from '@material-ui/core/Tooltip';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from '../style/gstheme';
import namespaces from '../utils/namespaces';

const namespaceKeys = Object.keys(namespaces);

class SparqlSelectResultsViewer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            pageSize: 50,
            size: props.data.results.bindings.length
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.data.results.bindings.length !== state.size) {
            return {
                size: props.data.results.bindings.length,
                page: 1
            };
        }
        return null;
    }

    checkForPrefix(iri) {
        const ns = namespaceKeys.find(prefix => iri && iri.startsWith(prefix) ? true : false);
        return ns ? namespaces[ns] + ":" + iri.substring(ns.length) : iri;
    }

    handlePagingChange = (page) => this.setState({ page });

    handleSizeChange = (pageSize) => this.setState({ page: 1, pageSize });

    render() {

        const { classes, data } = this.props;
        const { page, pageSize } = this.state;

        const columns = data.head ? data.head.vars : [];
        const results = data.results ? data.results.bindings : [];
        const displayStartIndex = (pageSize * page) - pageSize + 1;
        const displayResults = results.slice(displayStartIndex - 1, displayStartIndex - 1 + pageSize);
        const maxDisplayCount = Math.min(displayStartIndex + pageSize - 1, results.length);
        const pageCount = Math.floor((results.length + pageSize - 1) / pageSize);

        if (maxDisplayCount === 0) {
            return <ActionText offset="50px">There are no results for this query.</ActionText>;
        }

        return (
            <div>
                <div style={{ display: 'flex', marginBottom: 20, marginTop: 12 }}>
                    {results.length > 50 &&
                        <React.Fragment>
                            <div style={{ flex: 1, marginTop: 25 }}>
                                <Typography data-test="showing" variant="body2" className={classes.showing}>Showing {displayStartIndex} to {maxDisplayCount} of {results.length} results.</Typography>
                            </div>
                            <div style={{ width: 130, alignSelf: 'right' }}>
                                <MenuSelector
                                    dataTest="page-size-selector"
                                    label="Results to Show"
                                    handleChange={this.handleSizeChange}
                                    selected={pageSize.toString()}
                                    hintWord="results size"
                                    options={[
                                        {
                                            value: 50,
                                            label: "50"
                                        },
                                        {
                                            value: 100,
                                            label: "100"
                                        },
                                        {
                                            value: 250,
                                            label: "250"
                                        },
                                        {
                                            value: 500,
                                            label: "500"
                                        }
                                    ]} />
                            </div>
                        </React.Fragment>
                    }
                </div>
                <div>
                    <Table data-test="result-viewer" size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell component="th" className={classes.tableHeading} style={{ width: 50 }}>No.</TableCell>
                                {columns.map((column, index) => <TableCell
                                    key={index}
                                    component="th"
                                    className={classes.tableHeading}>{column}</TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {displayResults.map((result, index) =>
                                <TableRow
                                    data-test={"row-" + index}
                                    key={"row-" + index}
                                    classes={{
                                        root: classes.stripedRow
                                    }}>
                                    <TableCell
                                        component="th"
                                        className={classes.tableCell}>{displayStartIndex + index}
                                    </TableCell>
                                    {columns.map((column, index) => {
                                        if (!result[column]) {
                                            return <TableCell
                                                key={index}
                                                component="td"
                                                className={classes.tableCell}></TableCell>;
                                        }
                                        let displayValue = result[column] ? result[column].value : "";
                                        let prefixValue = displayValue;
                                        if (result[column].type === "uri") {
                                            prefixValue = this.checkForPrefix(result[column].value);
                                        }
                                        else {
                                            const append = result[column]["xml:lang"] ?
                                                "@" + result[column]["xml:lang"]
                                                :
                                                "";
                                            let dt = "";
                                            if (result[column].datatype) {
                                                dt = this.checkForPrefix(result[column].datatype);
                                                if (dt === result[column].datatype) {
                                                    dt = "<" + result[column].datatype + ">";
                                                }
                                                dt = "^^" + dt;
                                            }
                                            displayValue = `"${displayValue}"${append}${dt}`;
                                        }
                                        return <TableCell
                                            key={index}
                                            component="td"
                                            className={classes.tableCell}>{
                                                result[column].type === "uri" && prefixValue !== displayValue ?
                                                    <Tooltip placement="bottom-start" title={displayValue}>
                                                        <Typography className={classes.tableCellText}>{prefixValue}</Typography>
                                                    </Tooltip>
                                                    :
                                                    result[column].type === "bnode" ?
                                                        <Typography className={classes.tableCellText}>_:{result[column].value}</Typography>
                                                        :
                                                        <Typography className={classes.tableCellText}>{displayValue}</Typography>
                                            }
                                        </TableCell>;
                                    }
                                    )}
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    <Paging page={page} pageCount={pageCount} handlePageChange={this.handlePagingChange} pageItemsRange={5} />
                </div>
            </div>
        );
    }
}

SparqlSelectResultsViewer.defaultProps = {
};

SparqlSelectResultsViewer.propTypes = {
    data: PropTypes.object,
    queryType: PropTypes.string,
    classes: PropTypes.object
};

export default withStyles(styles)(SparqlSelectResultsViewer);